import { FC, PropsWithChildren } from 'react';

import { Box, SvgIconProps } from '@mui/material';
import { WidgetIconProps } from 'icons/widgets/types';
import { SxStyles } from 'types';

import './index.scss';

const blockStyles: SxStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

interface IPdfCommonDataEntityContainerProps {
  title: string;
  Icon: React.FC<SvgIconProps> | React.FC<WidgetIconProps>;
}

const PdfCommonDataEntityContainer: FC<IPdfCommonDataEntityContainerProps & PropsWithChildren> = ({
  title,
  Icon,
  children,
}) => (
  <div className="pdf-data-entity-container">
    <div className="pdf-data-entity-container__header">
      <Box sx={blockStyles}>
        <Icon width={24} height={24} iconType="filled" />
        <h3 className="pdf-data-entity-container__title">{title}</h3>
      </Box>
    </div>
    <div className="pdf-data-entity-container__content">{children}</div>
  </div>
);

export default PdfCommonDataEntityContainer;
